import { SORT_ASC, SORT_DESC, SORT_NO_SORT, SortOrder } from './sort-state';

const ICON_CLASS_ASC = 'icon-sort-ascending';
const ICON_CLASS_DESC = 'icon-sort-descending';

/**
 * Sort Module
 */
export default class SortModule {
  static nextSortState(state: SortOrder) {
    return state === SORT_DESC ? SORT_ASC : state === SORT_ASC ? SORT_NO_SORT : SORT_DESC;
  }

  static sortIcon(order: SortOrder) {
    const iconMap = {
      [SORT_ASC]: ICON_CLASS_DESC,
      [SORT_DESC]: ICON_CLASS_ASC,
      [SORT_NO_SORT]: ICON_CLASS_DESC,
    };

    return iconMap[order];
  }
}
